<style lang="scss">
.visitor-feedback-details-modal {
  max-height: 500px;
  overflow-y: auto;
}
</style>

<!-- eslint-disable -->
<template>
  <div class="visitor-feedback-details-modal">
    <div v-for="response in feedback.feedback" :key="response.question_id">
      <h4>{{response.title}}</h4>
      <p>{{response.responses.filter((item) => {
        return item && item.length > 1;
        }).toString() || '-'}}</p>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      feedback: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {};
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
